import type { CurrentUser } from "@outschool/ui-auth";
import { useFeatureFlag } from "@outschool/ui-components-shared";

export const useBroadcastMessageFlag = (currentUser: CurrentUser) => {
  const isFeatureOn = useFeatureFlag("bulk-messaging");
  const isUserSellerOrgAdmin = !!currentUser?.sellerOrg?.currentUserIsOwner;
  const isUserIndependentTeacher =
    !currentUser?.sellerOrg?.currentUserIsTeacher &&
    !!currentUser?.teacher_approved_at;
  return isFeatureOn && (isUserSellerOrgAdmin || isUserIndependentTeacher);
};
